import React from "react"

import { Form, Formik } from "formik"
import { NotificationManager } from "react-notifications"
import * as Yup from "yup"

import { gql, useMutation } from "hooks/urql"

import {
  FormFailures,
  SubmitButton,
  TextAreaField,
  handleFailure,
} from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const ValidationSchema = Yup.object().shape({
  reason: Yup.string().required("Please provide a reason for deferment"),
})

const DeferApplicant = ({ id }) => {
  const formState = { id, reason: "" }
  const [, runMutation] = useMutation(workflowMutation)

  const handleSubmit = (values, actions, closeModal) => {
    runMutation(values).then(result => {
      if (result.error) {
        handleFailure(actions, [{ message: result.error.message }])
        return
      }
      if (result.errors) {
        handleFailure(actions, result.errors)
        return
      }

      const { failures } = result.data.deferTutorApplication
      if (failures) {
        handleFailure(actions, failures)
      } else {
        NotificationManager.success("Applicant deferred")
        closeModal()
      }
    })
  }

  return (
    <ModalWithProvidedBody
      buttonText="Defer Applicant"
      buttonClassName="btn btn-warning"
      modalTitle="Defer Applicant"
    >
      {({ closeModal }) => (
        <Formik
          initialValues={formState}
          validationSchema={ValidationSchema}
          onSubmit={(values, actions) =>
            handleSubmit(values, actions, closeModal)
          }
        >
          <Form>
            <div className="modal-body">
              <TextAreaField name="reason" label="Reason" autoFocus />
            </div>

            <div className="modal-footer flex-col">
              <FormFailures />
              <div className="flex w-full justify-between">
                <button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-danger"
                >
                  Cancel
                </button>
                <SubmitButton text="Defer" />
              </div>
            </div>
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const workflowMutation = gql`
  mutation ($id: ID!, $reason: String!) {
    deferTutorApplication(id: $id, reason: $reason) {
      failures {
        message
      }
      tutorApplication {
        id
      }
    }
  }
`

export default DeferApplicant
